import React from 'react';
import PropTypes from 'prop-types';

import IClinicalMedicationHistory from '../interfaces/clinical-medication-history';
import ClinicalMedicationHistoryListItem from './clinical-medication-history-list-item';

const ClinicalMedicationHistoryList = ({ histories }) => (
  <tr>
    <td colSpan="3">
      <table>
        <thead>
          <tr>
            <th>Status</th>
            <th>Changed On</th>
            <th>Changed By</th>
          </tr>
        </thead>
        <tbody>
          {histories.map(history => (
            <ClinicalMedicationHistoryListItem key={history.id} history={history} />
          ))}
        </tbody>
      </table>
    </td>
  </tr>
);

ClinicalMedicationHistoryList.propTypes = {
  histories: PropTypes.arrayOf(IClinicalMedicationHistory)
};

export default ClinicalMedicationHistoryList;
